var React = require('react');
var ReactNative = require('react-native');

var moment = require('moment');
var ReUpText = require('./ReUpText');

var {
  View,
  StyleSheet,
  
  ScrollView
} = ReactNative;

var ReUpCountdown = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      countdownComplete:function(){},
      completionText:"now!",
      endDate:null,
    }
  },

  getInitialState : function()
  {
    return {
      counterText:"",
      counterStartDate:null,
    }
  },

  componentDidMount : function()
  {
    if( this.props.endDate != null )
    {
      this.startCountdown(this.props.endDate)
    }
  },

  componentWillUnmount : function()
  {
    this.stopCountdown();
  },

  _theTimeout: null,
  _endSeconds: null,
  startCountdown : function(endDate)
  {
    if( typeof endDate !== 'undefined' )
    {
      this.stopCountdown();
      this._endDate = endDate;
    }

    var shouldContinue = this._updateTimer();
    if( shouldContinue )
    {
      var thisThing = this;
      this._theTimeout = setTimeout(function()
      {
        thisThing.startCountdown();
      }, 200)
    }
  },

  stopCountdown : function()
  {
    if( this._theTimeout != null ) clearTimeout(this._theTimeout);

    this._theTimeout = null;
  },

  _updateTimer : function()
  {
    var now = new Date();
    var newCounterText = this.props.appManager.timeTill(this._endDate.getTime()/1000);
    if( now.getTime() >= this._endDate.getTime())
    {
      newCounterText = this.props.completionText;
      if( this.props.complete ) this.props.complete();
    }
    if( newCounterText != this.state.counterText ) this.setState({counterText: newCounterText});

    return (now.getTime() < this._endDate.getTime())
  },

  render: function()
  {
    return(
      <ReUpText {...this.props}>
        {this.state.counterText}
      </ReUpText>
    )
  }
});

module.exports = ReUpCountdown;



// WEBPACK FOOTER //
// ./src/ReUpCountdown.js